__turbopack_context__.v({
  "buttonActive": "index-module-scss-module__IMdiuW__buttonActive",
  "buttonDisable": "index-module-scss-module__IMdiuW__buttonDisable",
  "editor": "index-module-scss-module__IMdiuW__editor",
  "fileItem": "index-module-scss-module__IMdiuW__fileItem",
  "filesGrid": "index-module-scss-module__IMdiuW__filesGrid",
  "gridLayout": "index-module-scss-module__IMdiuW__gridLayout",
  "imageGalery": "index-module-scss-module__IMdiuW__imageGalery",
  "imageOutils": "index-module-scss-module__IMdiuW__imageOutils",
  "languageContain": "index-module-scss-module__IMdiuW__languageContain",
  "metaInfo": "index-module-scss-module__IMdiuW__metaInfo",
  "nextProj": "index-module-scss-module__IMdiuW__nextProj",
  "nextProjImage": "index-module-scss-module__IMdiuW__nextProjImage",
  "nextProjTitle": "index-module-scss-module__IMdiuW__nextProjTitle",
  "outilItemContent": "index-module-scss-module__IMdiuW__outilItemContent",
  "outilsContain": "index-module-scss-module__IMdiuW__outilsContain",
  "pdfFile": "index-module-scss-module__IMdiuW__pdfFile",
  "progressArticle": "index-module-scss-module__IMdiuW__progressArticle",
  "projectBanner": "index-module-scss-module__IMdiuW__projectBanner",
  "projectBody": "index-module-scss-module__IMdiuW__projectBody",
  "projectDates": "index-module-scss-module__IMdiuW__projectDates",
  "projectGalery": "index-module-scss-module__IMdiuW__projectGalery",
  "projectHeader": "index-module-scss-module__IMdiuW__projectHeader",
  "projectImage": "index-module-scss-module__IMdiuW__projectImage",
  "projectMain": "index-module-scss-module__IMdiuW__projectMain",
  "projectOutilMobile": "index-module-scss-module__IMdiuW__projectOutilMobile",
  "projetPara": "index-module-scss-module__IMdiuW__projetPara",
  "subtitle": "index-module-scss-module__IMdiuW__subtitle",
  "subtitleBlack": "index-module-scss-module__IMdiuW__subtitleBlack",
  "subtitleOutils": "index-module-scss-module__IMdiuW__subtitleOutils",
  "summary": "index-module-scss-module__IMdiuW__summary",
  "textContent": "index-module-scss-module__IMdiuW__textContent",
  "titleContain": "index-module-scss-module__IMdiuW__titleContain",
  "toolBar": "index-module-scss-module__IMdiuW__toolBar",
  "video": "index-module-scss-module__IMdiuW__video",
});
